/**
 * Created by zoupeiyang on 2017/9/7.
 */


/**
 * Created by zoupeiyang on 16/5/13.
 */
import { getDevSn, tlMd5, getDev } from './deviceOperate'


/*
 * 定义常用的公共方法，需使用时引用该JS文件，非必须加载项
 */

//时间对象格式化
Date.prototype.format = function(format) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds()
    }
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}

export function timeMsg() {
    var now = new Date();
    var hour = now.getHours();
    var out = "";
    if (hour < 6) {
        out += "凌晨好";
    } else if (hour < 9) {
        out += "早上好";
    } else if (hour < 12) {
        out += "上午好";
    } else if (hour < 14) {
        out += "中午好";
    } else if (hour < 17) {
        out += "下午好";
    } else if (hour < 19) {
        out += "傍晚好";
    } else if (hour < 22) {
        out += "晚上好";
    } else { out += "夜里好"; }
    var dayNames = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
    out += "，  今天是" + parseInt(now.getYear() + 1900) + "年" + (now.getMonth() + 1) + "月" + now.getDate() + "日" + " " + dayNames[now.getDay()] + "";
    return out;
}

//获取时间戳
export function getUnixTime(dateStr) {
    var newstr = dateStr.replace(/-/g, '/');
    var date = new Date(newstr);
    var time_str = date.valueOf();
    return time_str;
}

//返回当前日期
export function nowDate() {
    var dt = new Date();
    return (dt.format("yyyy-MM-dd"))
}

//返回当前日期的年月
export function nowYear() {
    var dt = new Date();
    return (dt.format("yyyy-MM"))
}

//返回当前日期戳
export function nowDates() {
    var dt = new Date();
    return (dt.format("yyyyMMdd"))
}

//返回当前日期加一天
export function nowAddDate() {
    var now = new Date();
    now.setDate(now.getDate() + 1);
    return (now.format("yyyy-MM-dd"))
}

export function nowAddDates() {
    var now = new Date();
    now.setDate(now.getDate() + 1);
    return (now.format("yyyy-MM"))
}
//获取本月最后一天
export function nowMonthLastDay() {
    let date = new Date();
    let currentMonth = date.getMonth();
    let nextMonth = ++currentMonth;
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    let oneDay = 1000 * 60 * 60 * 24;
    let year = new Date(nextMonthFirstDay - oneDay).getFullYear();
    let month = new Date(nextMonthFirstDay - oneDay).getMonth() + 1;
    let monthLastDay = new Date(nextMonthFirstDay - oneDay).getDate();
    let da = year + "-" + month + "-" + monthLastDay;
    return da;
}
export function nowSubDate(id) {
    var now = new Date();
    now.setDate(now.getDate() - id);
    return (now.format("yyyyMMdd"))
}
export function nowSubDates(id) {
    var now = new Date();
    now.setDate(now.getDate() - id);
    return (now.format("yyyyMM"))
}
//返回昨天日期
export function nowSubYear(id) {
    var now = new Date();
    now.setDate(now.getDate() - id);
    return (now.format("yyyy-MM-dd"))
}

//取当前时间,返回 yyyy-MM-dd hh:mm:ss
export function nowTime() {
    var dt = new Date();
    return dt.format("yyyy-MM-dd hh:mm:ss");
}



export function datetimeFormat(format) {
    var dt = new Date();
    return (dt.format(format))
}


//左填补,支持中文
export function LPad(str, len, fillval) {
    return new Array(Math.abs(str.toString().length - (len + 1))).join(fillval) + str;
}

//右填补,支持中文
export function RPad(str, len, fillval) {
    return str + new Array(Math.abs(str.toString().length - (len + 1))).join(fillval);
}

export function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return (r[2]);
    return null;
}

//判断手机号是否合法
export function isMobileNumber(mobileNumber) {
    let patrn = /^1\d{10}$/;
    if (!patrn.test(mobileNumber)) return false
    return true
}

/**
 * 创建订单号
 */
export function createTradeNo() {

    return global.LOCAL_DATA.systemInfo.devInfo.dev_id + (new Date()).valueOf();
}

export function createTicketNo() {
    return global.LOCAL_DATA.systemInfo.devInfo.dev_id + parseInt((new Date()).valueOf() / 1000);

}
export function createSettleNo() {
    return global.LOCAL_DATA.systemInfo.devInfo.dev_id + parseInt((new Date()).valueOf() / 1000);
}


//对字符串判空
export function empty(object) {
    if (object == null || object == "" || object == undefined)
        return true;
    else
        return false;
}

export function isIE() {
    let explorer = navigator.userAgent;
    if (explorer.indexOf("MSIE") >= 0 || explorer.indexOf("Windows") >= 0) {
        return true;
    } else {
        return false;
    }
}

//是否是android上的点击事件
export function androidClick() {

    // let version = getDev().GetSystemEnv('ROOTPATH');
    // if(version.substr(version.length-1,1)=="\\"&&window.event.type=="click"){
    //     return true;
    // }else {
    //     return false;
    // }


    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
    if (window.event.type == "click" && isAndroid) {
        return true;
    } else
        return false;

}


//改变视频声音大小
export function changeVideoVolume(volume) {

    if (volume == undefined)
        volume = 0.2;
    try {
        document.getElementById("video").volume = volume;
        // $("#appFrame2").contents().find("#video")[0].volume = volume;

    } catch (e) {}

}

export function loadAudioSrc(tex, vol, per, spd, pit) {

    try {
        if (!global.LOCAL_DATA.devInfo.onLine)
            return;
        changeVideoVolume(0.01);
        let cuid = global.LOCAL_DATA.systemInfo.devInfo.dev_id;
        if (!vol)
            vol = 9;
        if (!per) {
            per = global.LOCAL_DATA.devInfo.systemSetUp.sound_sex;
        }
        if (!spd)
            spd = 5;
        if (!pit)
            pit = 5;
        tex = encodeURI(tex);
        let tok = global.LOCAL_DATA.systemInfo.devInfo.baidu_volume_token;
        let audio = document.getElementById("audio");
        audio.src = "http://tsn.baidu.com/text2audio?tex=" + tex + "&lan=zh&cuid=" + cuid + "&ctp=1&tok=" + tok + "&vol=" + vol + "&per=" + per + "&spd=" + spd + "&pit=" + pit;

        //safari浏览器不支持自动播放语音功能
        audio.play();
    } catch (e) {

    }

}

export function audioEnd() {
    changeVideoVolume(0.8);
}

export function getReqData() {

    let reqData = {};
    reqData.enterprise_uid = global.LOCAL_DATA.systemInfo.devInfo.enterprise_uid;
    reqData.store_uid = global.LOCAL_DATA.systemInfo.devInfo.store_uid;
    reqData.dev_id = global.LOCAL_DATA.systemInfo.devInfo.dev_id;
    return reqData;
}


export function getSignReqData() {

    let reqData = {};
    reqData.dev_sn = global.LOCAL_DATA.devInfo.devSn;
    reqData.random = getRandom(10);
    reqData.time_stamp = (new Date()).valueOf();
    reqData.sign = getSign(reqData.dev_sn, reqData.random, reqData.time_stamp);
    reqData.enterprise_uid = global.LOCAL_DATA.systemInfo.devInfo ? global.LOCAL_DATA.systemInfo.devInfo.enterprise_uid : "";
    return reqData;
}

function getSign(devSn, random, timeStamp) {
    return tlMd5("dev_sn=" + devSn + "&random=" + random + "&time_stamp=" + timeStamp + "&key=" + global.LOCAL_DATA.devInfo.tlKey);
}


/**
 * 获取随机数
 * @param n
 * @returns {string}
 */
export function getRandom(n) {
    var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var res = "";
    for (var i = 0; i < n; i++) {
        var id = Math.ceil(Math.random() * 35);
        res += chars[id];
    }
    return res;

}

/**
 * 网络状态图标
 * @param onLine
 */
export function netStatusChange(onLine) {
    // if (onLine) {
    //     document.getElementById("netStatus").setAttribute("src", "../../../static/image/theme/default/dot.png")
    // } else {
    //     document.getElementById("netStatus").setAttribute("src", "../../../static/image/theme/default/net-bad.png")
    //
    // }

}

export function isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if (regPos.test(val) || regNeg.test(val)) {
        return true;
    } else {
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/jssFunction.js